import React from "react";

export function Logo({ className = "h-8", light = false }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img src={light ? "/logo-white.webp" : "/logo.webp"} alt="Suvera Flow" className="h-full w-auto object-contain" data-testid="brand-logo" />
    </div>
  );
}

export function LogoMark({ size = 36 }) {
  return (
    <div
      className="rounded-xl flex items-center justify-center font-display font-extrabold text-white relative overflow-hidden"
      style={{ width: size, height: size, background: "#16305B" }}
    >
      <span className="relative z-10 text-lg">s</span>
      <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full" style={{ background: "#2563EB" }} />
      <span className="absolute bottom-1 left-1 w-1.5 h-1.5 rounded-full" style={{ background: "#EF4444" }} />
    </div>
  );
}
